(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rsm-bbs-finish-strip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/bbs-"]')).forEach(function (link) {
      if (link.closest('.rsm-bbs-strip') || link.closest('.rsm-bbs-palette') || link.closest('.rsm-bbs-gallery')) return;
      var card = link.closest('.card-wrapper');
      if (!card) return;
      card.classList.add('rsm-bbs-listing-card-white');
    });

    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    if (window.location.pathname.indexOf('/products/bbs-') === 0) {
      var productForms = Array.prototype.slice.call(document.querySelectorAll('product-form form[action*="/cart/add"], form[action*="/cart/add"]'));
      var productForm = productForms.filter(function (form) {
        return form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]');
      })[0] || productForms[0];
      if (productForm && !productForm.querySelector('.rsm-bbs-product-notes')) {
        var notes = document.createElement('div');
        notes.className = 'rsm-bbs-product-notes';
        notes.innerHTML = '<label for="rsm-bbs-fitment-notes">Offset / application notes</label><textarea id="rsm-bbs-fitment-notes" name="properties[Offset / application notes]" placeholder="Desired offset, vehicle year/make/model, brake package, suspension, tire size, finish, shipping notes, or any other details we should confirm."></textarea><p>BBS Motorsport wheels are special-order and typically built to order. We will confirm fitment, offset, finish availability, pricing, and ETA before finalizing your order.</p>';
        var target = productForm.querySelector('.product-form__buttons') || productForm.querySelector('button[name="add"]');
        if (target && target.parentNode) {
          target.parentNode.insertBefore(notes, target);
        } else {
          productForm.appendChild(notes);
        }
      }
    }

    var handles = ['bbs-e07-19', 'bbs-e88-19', 'bbs-e87', 'bbs-e50'];
    if (handles.indexOf(handle) === -1) return;
    Array.prototype.slice.call(document.querySelectorAll('main details')).forEach(function (detail) {
      detail.setAttribute('open', '');
    });
    Array.prototype.slice.call(document.querySelectorAll('small')).forEach(function (note) {
      if (note.textContent.trim().toLowerCase() !== 'images courtesy of bbs motorsport.') return;
      var wrapper = note.closest('p');
      if (wrapper) wrapper.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll('h3')).forEach(function (heading) {
      if (heading.textContent.trim() !== 'BBS Motorsport Finish Palette') return;
      var grid = heading.parentElement && heading.parentElement.querySelector('div[style*="display:grid"]');
      if (!grid || grid.querySelector('.rsm-bbs-product-white-gold-card')) return;
      var card = document.createElement('div');
      card.className = 'rsm-bbs-product-white-gold-card';
      card.setAttribute('style', 'display:grid;place-items:center;align-content:center;justify-content:center;justify-items:center;gap:8px;min-height:112px;padding:12px;border:1px solid rgba(18,18,18,.12);border-radius:8px;background:#fff;text-align:center;');
      card.innerHTML = '<span style="width:30px;height:30px;border-radius:50%;background:#efe7d2;border:1px solid #b6ab90;display:inline-block;"></span><strong style="font-size:13px;">White Gold request</strong><small style="display:block;color:rgba(18,18,18,.68);line-height:1.35;">BBS special color. Request availability with your quote.</small>';
      grid.appendChild(card);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
